import { types, actions } from './requests'
export const UPLOADIMAGE_TYPES = {
    ...types('UPLOADIMAGE'),
}
export const UPLOADIMAGE_ACTIONS = {
    ...actions('UPLOADIMAGE'),
}
